import FLD from "../model/ISIN";
import {
    validateCfiBelongsToDsb,
    validateCfiCodeInstrumentCategory,
    validateCfiCodeInterestType,
    validateCfiCodeMaturityDate,
    validateCfiCodeStartingWithDM, validateXtIsinCfiStartsWithT
} from "./cfiValidation";

const isDeleteStatus = (values) => {
    let isinStatus = values[FLD.isinStatus];
    return isinStatus === 'D'
}

export const cfiValidater = (cfiCode: string, values) => {
    if(!isDeleteStatus(values)){
        if (!cfiCode) {
            return 'ra.validation.required';
        }
        if(!/^[A-Z]{6}$/.test(cfiCode)){
            return 'anna.validation.cfiCode'
        }
        return hardCfiValidation(cfiCode, values)
    }
    return undefined
}

export const fisnValidater = (value: string, values) => {
    if(!isDeleteStatus(values)){
        if(!value) {
            return 'ra.validation.required';
        }
        if(value.length > 35) {
            return 'FISN must be 35 characters or less';
        }
        if(value !== value.toUpperCase()) {
            return 'FISN must be in upper-case characters';
        }
    }
    return undefined;
};

export function cfiValidationAll(cfiCode: string, interestType: string, instrumentCategory: string, maturityDateCode: string): string {
    return validateCfiBelongsToDsb(cfiCode) ||
        validateCfiCodeInstrumentCategory(cfiCode, instrumentCategory) ||
        validateCfiCodeInterestType(cfiCode, interestType, instrumentCategory) ||
        validateCfiCodeMaturityDate(cfiCode, instrumentCategory, maturityDateCode, interestType) ||
        validateCfiCodeStartingWithDM(cfiCode, instrumentCategory);
};

function hardCfiValidation(cfiCode: string, values) {
    let instrumentCategory = values[FLD.instrumentCategory];
    let isinStatus = values[FLD.isinStatus];
    let cfiVersion = values[FLD.cfiVersion];

    const xtCfiValidationText = validateXtIsinCfiStartsWithT(values[FLD.id], cfiCode);

    if (xtCfiValidationText !== undefined) {
        return xtCfiValidationText;
    }

    let validationTextFor2019 = cfiValidationAll(
        cfiCode,
        values[FLD.interestType],
        instrumentCategory,
        values[FLD.maturityDateCode]
    );

    // In case the ISIN will be updated in an older cfiVersion and the CFI is not valid show a specific message.
    if (
        validationTextFor2019 !== undefined &&
        cfiVersion.includes("CFI2001") &&
        (isinStatus.includes("U") || isinStatus.includes("D") || isinStatus.includes("I"))
    ) {
        return "Please ensure CFI Version is set to 2019/2021 in order to validate the changes properly";
    }

    return validationTextFor2019;
}